module.exports = ".heit-400[_ngcontent-c13] {\r\n    height: 1000px;\r\n    overflow-y: auto;\r\n}"